module.exports = __webpack_public_path__ + "img/51_lg.7bd50c14.jpg";